import { DatePipe, NgClass, NgFor, NgIf } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { NgxPaginationModule } from "ngx-pagination";
import swal from "sweetalert2";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { AutorizacionTiempoExtra } from "src/app/shared/model/tarea/autorizacion-tiempo-extra.model";
import { GenericoService } from "src/app/shared/services/generico.service";
import { SweetAlertComponent } from "src/app/shared/SweetMesssage";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

@Component({
  selector: "app-autorizaciones-tiempo-extra",
  standalone: true,
  templateUrl: "./autorizaciones-tiempo-extra.component.html",
  styleUrls: ["./autorizaciones-tiempo-extra.component.css"],
  imports: [
    NgIf,
    NgFor,
    NgClass,
    FormsModule,
    DatePipe,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxPaginationModule,
  ],
})
export class AutorizacionesTiempoExtraComponent implements OnInit {
  readonly pageSize = 8;

  pendientesLider: AutorizacionTiempoExtra[] = [];
  solicitudesUsuario: AutorizacionTiempoExtra[] = [];
  filtroMisSolicitudes = "TODOS";

  currentPagePendientes = 1;
  currentPageSolicitudes = 1;

  constructor(
    private genericoService: GenericoService,
    private sweetAlert: SweetAlertComponent
  ) {}

  ngOnInit(): void {
    this.cargarPendientesLider();
    this.cargarSolicitudesUsuario();
  }

  cargarPendientesLider(): void {
    this.genericoService
      .consultarXPaginacion(
        UrlConstantes.CONSULTA_TIEMPO_EXTRA_LIDER,
        new ConsultaList<AutorizacionTiempoExtra>()
      )
      .subscribe((response) => {
        this.pendientesLider = Array.isArray(response?.list) ? response.list : [];
      });
  }

  cargarSolicitudesUsuario(): void {
    const request = new ConsultaList<AutorizacionTiempoExtra>();
    request.bean = new AutorizacionTiempoExtra();
    request.bean.estatus =
      this.filtroMisSolicitudes === "TODOS" ? null : this.filtroMisSolicitudes;

    this.genericoService
      .consultarXPaginacion(UrlConstantes.CONSULTA_TIEMPO_EXTRA_USUARIO, request)
      .subscribe((response) => {
        this.solicitudesUsuario = Array.isArray(response?.list) ? response.list : [];
      });
  }

  onFiltroMisSolicitudesChange(): void {
    this.currentPageSolicitudes = 1;
    this.cargarSolicitudesUsuario();
  }

  resolverSolicitud(
    solicitud: AutorizacionTiempoExtra,
    estatus: "APROBADO" | "RECHAZADO"
  ): void {
    const titulo =
      estatus === "APROBADO" ? "Aprobar tiempo extra" : "Rechazar tiempo extra";

    swal
      .fire({
        title: titulo,
        html:
          estatus === "APROBADO"
            ? `
              <input id="swal-minutos-aprobados" class="swal2-input" type="number" min="1" max="${solicitud.minutosSolicitados}" placeholder="Minutos aprobados" value="${solicitud.minutosSolicitados}">
              <textarea id="swal-comentario-lider" class="swal2-textarea" placeholder="Comentario del líder (opcional)"></textarea>
            `
            : `
              <textarea id="swal-comentario-lider" class="swal2-textarea" placeholder="Explica por qué se rechaza"></textarea>
            `,
        showCancelButton: true,
        confirmButtonText: estatus === "APROBADO" ? "Aprobar" : "Rechazar",
        cancelButtonText: "Cancelar",
        focusConfirm: false,
        preConfirm: () => {
          const comentario = (
            document.getElementById("swal-comentario-lider") as HTMLTextAreaElement | null
          )?.value?.trim();

          if (estatus === "APROBADO") {
            const minutosAprobados = Number(
              (
                document.getElementById(
                  "swal-minutos-aprobados"
                ) as HTMLInputElement | null
              )?.value
            );
            if (
              !Number.isFinite(minutosAprobados) ||
              minutosAprobados <= 0 ||
              minutosAprobados > solicitud.minutosSolicitados
            ) {
              swal.showValidationMessage(
                "Los minutos aprobados deben ser mayores a cero y no exceder lo solicitado."
              );
              return null;
            }
            return { comentario, minutosAprobados };
          }

          if (!comentario) {
            swal.showValidationMessage(
              "Captura un comentario para justificar el rechazo."
            );
            return null;
          }

          return { comentario, minutosAprobados: 0 };
        },
      })
      .then((result) => {
        if (!result.isConfirmed || !result.value) {
          return;
        }

        const payload = new AutorizacionTiempoExtra();
        payload.id = solicitud.id;
        payload.estatus = estatus;
        payload.minutosAprobados = result.value.minutosAprobados;
        payload.comentarioLider = result.value.comentario;

        this.genericoService
          .agregarElemento(UrlConstantes.RESOLVER_TIEMPO_EXTRA, payload)
          .subscribe((response) => {
            if (response?.pCodRetorno === "00000") {
              this.sweetAlert.showSwal("success-message-msg", response.pMensaje);
              this.cargarPendientesLider();
              this.cargarSolicitudesUsuario();
            } else {
              this.sweetAlert.showSwal(
                "error-message-msg",
                response?.pMensaje || "No fue posible resolver la solicitud."
              );
            }
          });
      });
  }

  get pendientesTotal(): number {
    return this.pendientesLider.length;
  }

  get aprobadasTotal(): number {
    return this.solicitudesUsuario.filter((item) => item.estatus === "APROBADO").length;
  }

  get pendientesPropiasTotal(): number {
    return this.solicitudesUsuario.filter((item) => item.estatus === "PENDIENTE").length;
  }

  get rechazadasTotal(): number {
    return this.solicitudesUsuario.filter((item) => item.estatus === "RECHAZADO").length;
  }

  get showPendientesPagination(): boolean {
    return this.pendientesLider.length > this.pageSize;
  }

  get showSolicitudesPagination(): boolean {
    return this.solicitudesUsuario.length > this.pageSize;
  }
}
